module.exports = __webpack_public_path__ + "img/express.d16c9f5a.png";